import { nanoid } from "nanoid";

//Animation Data, use it as a template
export const animationList = [
  {
    id: nanoid(),
    title: "Dots",
    data: require("./lotties/dots.json"),
  },
  {
    id: nanoid(),
    title: "Spinning Wheel",
    data: require("./lotties/spinning_wheel.json"),
  },
  {
    id: nanoid(),
    title: "Dots",
    data: require("./lotties/dots.json"),
  },
  {
    id: nanoid(),
    title: "Spinning Wheel",
    data: require("./lotties/spinning_wheel.json"),
  },
  {
    id: nanoid(),
    title: "Dots",
    data: require("./lotties/dots.json"),
  },
  {
    id: nanoid(),
    title: "Spinning Wheel",
    data: require("./lotties/spinning_wheel.json"),
  },
];
